import { memo } from 'react';
import { Box, Typography } from '@tempmee/react';
import { Pressable } from '~/commonComponents';

interface IFeedbackItemProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const FeedbackItemComponent = ({ label, isSelected, onClick }: IFeedbackItemProps) => (
  <Pressable key={label} onPress={onClick}>
    <Box
      className={`border rounded-3xl ${isSelected ? 'bg-primary-50 border-secondary-500' : 'bg-shades-0 border-neutral-100'}`}
      style={{ cursor: 'pointer', minWidth: 206 }}
    >
      <Typography as="span" style={{ paddingBlock: 8, paddingInline: 20 }}>
        {label}
      </Typography>
    </Box>
  </Pressable>
);

export const FeedbackItem = memo(FeedbackItemComponent);
